<template>
  <div class='clockDetail'>
    <van-datetime-picker
      v-model="clockTime"
      type="time"
      title="选择完整时间"
      :show-toolbar="false"
      :min-hour="0"
      :max-hour="23"
    />
    <div class="check_div" @click="show=true">
      <div class="check_left">重复</div>
      <div class="check_content">{{showWeeks}}</div>
      <div class="check_log"><img  src="../../../assets/img/mine/right.png" alt=""></div>
    </div>
    <van-action-sheet v-model="show">
      <div class="addCon">
         <p class="btn flex-between" style="position: unset;margin-left: 6%;"><span  @click="cncalClock">取消</span><b>重复</b><span class='sure' @click="sureClock">确定</span></p>
         <div class="wayCon">
           <p :class="item.check?'check':''" v-for='(item,i) in weekList' :key='i' 
            @click='item.check=!item.check'>每周{{item.text}}
            <span class="re_check" v-if="item.check"><div class="gou_chect"><van-icon name="success" /></div></span>
          </p>
         </div>
      </div>
    </van-action-sheet>
    
    <div class="btn-primary" @click='submitClock'>确定</div>
   
  <!--添加-->
  <van-action-sheet v-model="isAdd">
        <van-datetime-picker
          v-model="clockTime"
          type="time"
          title="选择时间" @confirm='confirm' @cancel='isAdd=false'
        />
  </van-action-sheet>
  </div>
</template>
<script>
import {clockUpdate,clockAdd} from "@/api/api.equipment";
  export default {
    data() {
      return {
        isAdd:false,
        show:false,
        clockTime:this.$route.query.clockTime||'',
        clockWeek:this.$route.query.clockWeek||[],
        id:this.$route.query.id||'',
        weekList:[{text:'一',value:'1',check:false},{text:'二',value:'2',check:false},
                  {text:'三',value:'3',check:false},{text:'四',value:'4',check:false},{text:'五',value:'5',check:false}
                  ,{text:'六',value:'6',check:false},{text:'日',value:'0',check:false}],
        showWeeks:"",
        submitWeeks:[],
        weeks:[{label:'周一',value:'1'},{label:'周二',value:'2'},{label:'周三',value:'3'},{label:'周四',value:'4'},{label:'周五',value:'5'},{label:'周六',value:'6'},{label:'周日',value:'0'}],//['周日','周一','周二','周三','周四','周五','周六'],
      }
    },
    created(){
      if(this.clockWeek.length!=0){
        this.clockWeek.forEach((check)=>{
          this.weekList.forEach((day)=>{
            if(day.value==check){
              day.check=true
            }
          })
        })
        this.updataWeek()
      }else{
        this.weekList=[{text:'一',value:'1',check:true},{text:'二',value:'2',check:true},
                  {text:'三',value:'3',check:true},{text:'四',value:'4',check:true},{text:'五',value:'5',check:true}
                  ,{text:'六',value:'6',check:false},{text:'日',value:'0',check:false}]
        this.updataWeek()
        
      }
      
      
      // this.weekList=
    },
    methods: {
        confirm(value){
          this.clockTime=value;
          this.isAdd=false;
        },
       submit(){
         if(this.clockTime==''){
           this.$toast('请设置闹钟时间');
           return false;
         }else if(this.clockWeek.length==0){
           this.$toast('请选择重复方式');
           return false;
         }
         let clockWeek=this.clockWeek.sort();
         if(clockWeek.indexOf('0')>-1){
           clockWeek=clockWeek.splice(1);
           clockWeek=clockWeek.join('')+'0';
         }else{
           clockWeek=clockWeek.join('');
         }
         let params={
                  studentId:this.loginUser.studentId,
                  clockTime:this.clockTime,
                  clockWeek:clockWeek,
                  id:this.id,
         };
         if(this.id){//编辑
           clockUpdate(params).then((data) => {
                if (data && data.result) {
                     this.cancle();
                }else{
                  this.$toast(data.message);
                }
            })
         }else{
           clockAdd(params).then((data) => {
                if (data && data.result) {
                     this.cancle();
                }else{
                  this.$toast(data.message);
                }
            })
         }
        
         
       },
       sureClock(){
        let arr=this.weekList.filter(item=>item.check);
        if(arr.length>0){
          this.updataWeek()
          this.show=false
        }else{
          this.$toast('请选择内容');
        }
        
       },
       cncalClock(){
        // this.updataWeek()
        // this.clockWeek.forEach((check)=>{
        //   this.weekList.forEach((day)=>{
        //     if(day.value==check){
        //       day.check=true
        //     }
        //   })
        // })
        // this.updataWeek()
        this.show=false
       },
       submitClock(){
        let params={
          studentId:this.loginUser.studentId,
          clockTime:this.clockTime || "00:00",
          clockWeek:this.submitWeeks.toString().replace(/,/g, ""),
          id:this.id
        }
        if(this.id){
          clockUpdate(params).then(() => {
            this.$router.go(-1)
          })
        }else{
          clockAdd(params).then(() => {
            this.$router.go(-1)
          })
        }
        
       },
       updataWeek(){
        let tempStr=''
        this.submitWeeks=[]
        this.weekList.forEach((item)=>{
          if(item.check){
            tempStr=tempStr+item.text+"/"
            this.submitWeeks.push(item.value)

          }
        })
        this.showWeeks="每周"+tempStr
       },
       cancle(){
         this.$router.go(-1);
       },
    },
  }
</script>
<style lang="scss" >
.clockDetail{
   padding:0.15rem;
   height:100%;
   .van-picker{
      background: transparent;
   }
   .check_div{
    display: flex;
    justify-content: space-between;
    height: 48px;
    background: #FFFFFF;
    border-radius: 8px 8px 8px 8px;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
    padding: 0.12rem;
    align-items: center;
    position: relative;
    
    .check_left{
      width: 12%;
      font-size: 17px;
      font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
      font-weight: 400;
      line-height: 17px;
      color: rgba(0,0,0,0.9);
    }
    .check_content{
      width: 84%;
      text-align: right;
      font-size: 16px;
      line-height: 16px;

      font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
      font-weight: 400;
      color: #666666;
    }
    .check_log{
      width: 4%;
      img{
        width: 0.2rem;
        height: 0.2rem;
        vertical-align: -10%;
      }
    }
   }
   .listWeek{
    line-height: .48rem;
    padding:0rem .12rem;
    font-size: .18rem;
    background: #fff;
    border-radius: 8px;
    margin-bottom: .22rem;
  }
   .wayCon{
    padding-left: 1%;
    padding-bottom: .1rem;
    
    p{
      background:#F5F5F5;
      color:#333333;
      font-size: .15rem;
      text-align: center;
      display: inline-block;
      width: 31%;
      line-height: .36rem;
      margin:.12rem 1% 0rem;
      position: relative;
    border-radius: 8px;
      overflow: hidden;
      .re_check{
        position: absolute;
        right: 0;
        bottom: 0;
        width: 0;
        height: 0;
        border-width: 0 0 0.20rem 0.28rem ;
        border-color: #1677FF  transparent;
        border-style: solid;
        .gou_chect{
        position: relative;
        right: 18px;
        top: -3px;
      }
      }
      
      span{
        width: .3rem;
        height: .3rem;
        text-align: center;
        color: #fff;
        // background: #1677FF;
        transform: rotateX('90');
      }
      &.check{
        background: #E7F1FF;
        color:#1677FF;
        
      }
    }
  }
  .list{
    padding:0.15rem;
    background: #fff;
    height: 100%;
    font-size: .13rem;
   position: relative;
    .van-checkbox-group{
      padding-top: 6px;
      .van-checkbox{
        margin-bottom: 10px;
      }
      .van-checkbox__label{
        line-height: .2rem;
      }
    }
    
  }
  .btn{
      position: absolute;
      bottom: .3rem;
      text-align: center;
      width: 88%;
      left: 6%;
      .margin20{
          margin-right:.15rem;
      }
  } 
}

</style>